import React, { useEffect } from "react";

export const Cursor = () => {
  const cursorDotName = "cursor-dot";
  const cursorOutlineName = "cursor-outline";

  useEffect(() => {
    const cursorDot = document.getElementsByClassName(
      cursorDotName,
    )[0] as HTMLElement;
    const cursorOutline = document.getElementsByClassName(
      cursorOutlineName,
    )[0] as HTMLElement;

    const handleMouseMove = (e: MouseEvent) => {
      const posX = e.clientX;
      const posY = e.clientY;

      cursorDot.style.left = `${posX}px`;
      cursorDot.style.top = `${posY}px`;

      cursorOutline.animate(
        [
          {
            left: `${posX}px`,
            top: `${posY}px`,
          },
        ],
        {
          duration: 200,
          fill: "forwards",
        },
      );
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [cursorDotName, cursorOutlineName]);

  return (
    <div>
      <div
        className={cursorDotName}
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
          zIndex: "100",
          pointerEvents: "none",
          width: "10px",
          height: "10px",
          backgroundColor: "white",
          border: "1px solid black",
        }}
      ></div>
      <div
        className={cursorOutlineName}
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
          zIndex: "100",
          pointerEvents: "none",
          width: "30px",
          height: "30px",
          border: "2px solid hsla(0, 0%, 100%, 0.5)",
        }}
      ></div>
    </div>
  );
};
